
    <div class="day-selector">
      <div class="day-selector__header">
        <h3 i18n="@@daySelectorComponentHeading">Select days</h3>
        <p><a href="#" (click)="selectAll($event)" i18n="@@daySelectorComponentSelectAll">Select all 7 days</a></p>
      </div>
      <div class="day-selector__content">
        <ul>
          <li *ngFor="let date of dates">
            <app-day-toggler
              [date]="date.date"
              [(ngModel)]="date.selected">
            </app-day-toggler>
          </li>
        </ul>
      </div>
    </div>
  